import type { PatientDiagnosis } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getPatientDiagnosis(patientId: string): Promise<PatientDiagnosis> {
  return sharedRequestsTyped.get_patient_diagnosis({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
